import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

import { Fields } from './Fields'

const CreateCaja = (props) => {
  const { open, handleClose, render, setRender, dataBefore } = props

  const createDismissableSnackbar = useCustomSnackbar()

  const [isLoading, setIsLoading] = useState(false)

  const [info, setInfo] = useState({
    empresa: 1,
    sucursal: null,
    fecha: new Date(),
  })

  const handleChange = (name, value) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  function _renderStepContent() {
    return <InputsWithoutValidate fields={Fields(info, handleChange, dataBefore)} spacing={2} />
  }

  const formatDate = (date) => {
    if (!date) return null
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const create = async () => {
    const values = {
      empresa: info.empresa,
      fecha: formatDate(info.fecha),
      sucursal: info.sucursal,
    }
    setIsLoading(true)
    await interfaces.salesCaja
      .create(values)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        handleClose()
        setRender(!render)
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    handleClose()
    setIsLoading(false)
  }

  function disabledSubmit() {
    return !info.sucursal
  }

  return (
    <DialogComponent
      title="Nueva caja"
      open={open}
      handleclose={handleClose}
      handleclosedisabled={isLoading}
      widthLarge="500px"
      disableBackdropClick
      disableEscapeKeyDown
      maxHeight
      children={
        <>
          <div>{_renderStepContent()}</div>
        </>
      }
      actions={
        <CancelConfirmButtons
          disabledSubmit={isLoading ? true : disabledSubmit()}
          disabledCancel={isLoading}
          isLoading={isLoading}
          onClickSubmit={create}
          onClickCancel={handleClose}
        />
      }
    />
  )
}
export default CreateCaja
